import './App.css';
import Header from './components/Header'
import RuleCard from './components/RuleCard'
import BingoCard from './components/BingoCard'
import BottomCard from './components/BottomCard'
import BingoPrompt from './components/prompt/BingoPrompt'

function App() {
  return (
    <>
      <Header />
      <RuleCard />
      <BingoCard />
      <BingoPrompt />
      <BottomCard />
    </>
  );
}

export default App;
